import http from '@/utils/http';

export default {
	list: data => {
		return http({ url: '/api/admin/v1/agreement/list', data }).then(r => r);
	},
	detail: data => {
		return http({ url: '/api/admin/v1/agreement/detail', data }).then(r => r);
	},
	centerList: data => {
		return http({ url: '/api/admin/v1/agreement/centerList', data }).then(r => r);
	},
	centerDetail: data => {
		return http({ url: '/api/admin/v1/agreement/centerDetail', data }).then(r => r);
	},
	save: (data, tip = true) => {
		return http({ url: '/api/admin/v1/agreement/save', data, tip }).then(r => r);
	},
	delete: data => {
		return http({ url: '/api/admin/v1/agreement/delete', data, tip: true }).then(r => r);
	},
	toggleStatus: data => {
		return http({ url: '/api/admin/v1/agreement/toggleStatus', data, tip: true }).then(r => r);
	},
	signVersionList: data => http({ url: '/api/admin/v1/agreement/signVersionList', data }).then(r => r),
	previewSignVersion: data => http({ url: '/api/admin/v1/agreement/previewSignVersion', data }).then(r => r),
	publishSignVersion: data => http({ url: '/api/admin/v1/agreement/publishSignVersion', data, tip: true }).then(r => r),
	disableSignVersion: data => http({ url: '/api/admin/v1/agreement/disableSignVersion', data, tip: true }).then(r => r),
};
